import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { useDispatch, useSelector } from "react-redux";
import { Charts } from "../views";
import { FETCH_CURRENT_USER } from "../common/saga";

const MODULE_HEIGHT = 550;

const InstructorUtilization = (props) => {
  const dispatch = useDispatch();
  const { isLoading, initialRequest } = useSelector((state) => state.instructorUtilization);
  const [filtersDirtySt1, setFiltersDirtySt1] = useState(false);

  useEffect(() => {
    fetchInitialData();
  }, []);

  function fetchInitialData(reset) {
    if (!initialRequest || reset) {
      dispatch({
        type: FETCH_CURRENT_USER + props.moduleName,
        payload: {
          chartType: props.moduleName,
          ...props
        }
      });

      setFiltersDirtySt1(false);
    }
  }

  return (
    <>
      <Charts
        sectionProps={{
          title: "Instructor Utilization",
          learnMore: (
            <KBLearnMore
              title="Instructor Utilization"
              description="This report shows how often instructors are scheduled and how frequently their classes are attended. These insights help you identify high-demand instructors, optimize class assignments, and balance staff workloads."
              kbUrl={ILEARN_URLS.instructorPerformance.instructorUtilization}
            />
          ),
          customClass: `instructorperformanceWidget ${isLoading ? "" : "active"}`,
          height: MODULE_HEIGHT,
          isLoading: isLoading
        }}
        currentUser={props}
        filtersDirtySt={filtersDirtySt1}
        fetchInitialData={fetchInitialData}
        isLoading={isLoading}
        moduleName={props.moduleName}
      />
    </>
  );
};

InstructorUtilization.propTypes = {
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  moduleName: PropTypes.string
};

export default InstructorUtilization;
